import { GoPlus } from 'react-icons/go';

import { Avatar } from '@/components';
import { extraGuestsTag } from '@/store/events/events.dto';

import styles from './ParticipantBadge.module.scss';

interface ParticipantBadgeProps {
  participantId: string;
  firstName: string;
  lastName?: string;
  participantRole?: string;
  avatarUrl?: null | string;
  declined?: boolean;
  /** Guests they bring along, shown as "+2" after the name. */
  extra?: number;
  onRemove?: () => void;
}

const ParticipantBadge: React.FC<ParticipantBadgeProps> = ({
  participantId,
  firstName,
  lastName,
  participantRole,
  avatarUrl,
  declined,
  extra,
  onRemove,
}) => {
  const displayName = `${lastName ? `${firstName} ${lastName}` : firstName}${extraGuestsTag(extra)}`;

  return (
    <div className={`${styles.participant}${declined ? ` ${styles.declined}` : ''}`}>
      <Avatar
        src={avatarUrl}
        firstName={firstName}
        lastName={lastName}
        size={24}
        alt={participantId}
      />
      <div className={styles.info}>
        <span className={styles.participantName}>{displayName}</span>
        {participantRole && <span className={styles.participantRole}>{participantRole}</span>}
      </div>
      {onRemove && (
        <button
          type="button"
          className={styles.removeButton}
          onClick={onRemove}
          aria-label="Remove participant"
        >
          <GoPlus className={styles.removeIcon} />
        </button>
      )}
    </div>
  );
};

export default ParticipantBadge;
